<template>
  <v-btn
    class="btn-custom ma-0"
    :style="'border-color:' + color"
    @click="$emit('click')"
    @touchend="$blurRipple($el)"
  >
    <div class="bloc d-flex align-center">
      <slot />
      <div class="mx-auto">
        <div class="title">
          {{ title }}
        </div>
        <div class="caption">
          {{ info }}
        </div>
      </div>
    </div>
  </v-btn>
</template>

<script>
import { LogoImages } from '@/modules/Images'
import { $blurRipple } from '@/modules/Utils'

export default {
  name: 'CustomBtn',

  props: {
    title: { type: String, required: true },
    info: { type: String, default: null },
    color: { type: String, default: 'grey' }
  },

  data () {
    return {
      LogoImages
    }
  },

  methods: {
    $blurRipple
  }
}
</script>

<style scoped>
.logo-payment {
  max-width: 80px;
  max-height: 48px;
}
</style>
